/** Hosted SPA hostname → API base URL (must match SymphonyBack ENVIRONMENT.md). */
export const HOSTED_API_BY_APP_HOST = {
    'dev.symphony-app.com': 'https://dev-api.symphony-app.com',
    'demo.symphony-app.com': 'https://api-demo.symphony-app.com',
    'app.symphony-app.com': 'https://api.symphony-app.com',
};

/**
 * @param {string} [hostname]
 * @returns {string | undefined}
 */
export function hostedApiForBrowser(hostname) {
    if (!hostname) {
        return undefined;
    }

    return HOSTED_API_BY_APP_HOST[hostname];
}

/**
 * @param {string} url
 * @returns {boolean}
 */
export function isLocalApiUrl(url) {
    return !url || /symphony\.test|localhost|127\.0\.0\.1/i.test(url);
}
